<!--Main data-->
<div class="MainData">
	<h4>Select the report file type and press continue</h4>

	<!--Selector-->
	<div>
		<!--File Type-->
		<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onContinue()">Continue</button>
	<button class="btn btn-secondary" (click)="onClose()">Cancel</button>
</div>
